import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

interface EyeIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const EyeIcon = ({ className, asChild = false }: EyeIconProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={`${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00016 2.40002C5.98016 2.40002 4.36266 3.32002 3.18516 4.41502C2.01516 5.50002 1.23266 6.80002 0.862656 7.69252C0.780156 7.89002 0.780156 8.11002 0.862656 8.30752C1.23266 9.20002 2.01516 10.5 3.18516 11.585C4.36266 12.68 5.98016 13.6 8.00016 13.6C10.0202 13.6 11.6377 12.68 12.8152 11.585C13.9852 10.4975 14.7677 9.20002 15.1402 8.30752C15.2227 8.11002 15.2227 7.89002 15.1402 7.69252C14.7677 6.80002 13.9852 5.50002 12.8152 4.41502C11.6377 3.32002 10.0202 2.40002 8.00016 2.40002ZM4.40016 8.00002C4.40016 7.04525 4.77944 6.12957 5.45457 5.45444C6.1297 4.77931 7.04538 4.40002 8.00016 4.40002C8.95494 4.40002 9.87061 4.77931 10.5457 5.45444C11.2209 6.12957 11.6002 7.04525 11.6002 8.00002C11.6002 8.9548 11.2209 9.87048 10.5457 10.5456C9.87061 11.2207 8.95494 11.6 8.00016 11.6C7.04538 11.6 6.1297 11.2207 5.45457 10.5456C4.77944 9.87048 4.40016 8.9548 4.40016 8.00002ZM8.00016 6.40002C8.00016 7.28252 7.28266 8.00002 6.40016 8.00002C6.22266 8.00002 6.05266 7.97002 5.89266 7.91752C5.75516 7.87252 5.59516 7.95753 5.60016 8.10253C5.60766 8.27503 5.63266 8.44752 5.68016 8.62002C6.02266 9.90002 7.34016 10.66 8.62016 10.3175C9.90016 9.97503 10.6602 8.65753 10.3177 7.37753C10.0402 6.34002 9.12266 5.64252 8.10266 5.60002C7.95766 5.59502 7.87266 5.75252 7.91766 5.89252C7.97016 6.05252 8.00016 6.22252 8.00016 6.40002Z"
        fill="#515B61"
      />
    </Comp>
  );
};

EyeIcon.displayName = "EyeIcon";

export { EyeIcon };
